__turbopack_context__.v({
  "addonPrefix": "Form-module__FbQFba__addonPrefix",
  "addonSuffix": "Form-module__FbQFba__addonSuffix",
  "checkboxField": "Form-module__FbQFba__checkboxField",
  "choiceInput": "Form-module__FbQFba__choiceInput",
  "choiceLabel": "Form-module__FbQFba__choiceLabel",
  "choiceText": "Form-module__FbQFba__choiceText",
  "control": "Form-module__FbQFba__control",
  "counter": "Form-module__FbQFba__counter",
  "counterOver": "Form-module__FbQFba__counterOver",
  "errorText": "Form-module__FbQFba__errorText",
  "field": "Form-module__FbQFba__field",
  "fieldRow": "Form-module__FbQFba__fieldRow",
  "form": "Form-module__FbQFba__form",
  "formHint": "Form-module__FbQFba__formHint",
  "formTitle": "Form-module__FbQFba__formTitle",
  "hint": "Form-module__FbQFba__hint",
  "honeypot": "Form-module__FbQFba__honeypot",
  "inputWithAddon": "Form-module__FbQFba__inputWithAddon",
  "invalid": "Form-module__FbQFba__invalid",
  "label": "Form-module__FbQFba__label",
  "linkButton": "Form-module__FbQFba__linkButton",
  "optional": "Form-module__FbQFba__optional",
  "passwordStrength": "Form-module__FbQFba__passwordStrength",
  "passwordToggleBtn": "Form-module__FbQFba__passwordToggleBtn",
  "passwordWrap": "Form-module__FbQFba__passwordWrap",
  "primaryButton": "Form-module__FbQFba__primaryButton",
  "required": "Form-module__FbQFba__required",
  "select": "Form-module__FbQFba__select",
  "status": "Form-module__FbQFba__status",
  "statusDismiss": "Form-module__FbQFba__statusDismiss",
  "statusError": "Form-module__FbQFba__statusError",
  "statusIcon": "Form-module__FbQFba__statusIcon",
  "statusInfo": "Form-module__FbQFba__statusInfo",
  "statusSuccess": "Form-module__FbQFba__statusSuccess",
  "statusText": "Form-module__FbQFba__statusText",
  "statusWarning": "Form-module__FbQFba__statusWarning",
  "strengthBar": "Form-module__FbQFba__strengthBar",
  "strengthBarLevel1": "Form-module__FbQFba__strengthBarLevel1",
  "strengthBarLevel2": "Form-module__FbQFba__strengthBarLevel2",
  "strengthBarLevel3": "Form-module__FbQFba__strengthBarLevel3",
  "strengthBarLevel4": "Form-module__FbQFba__strengthBarLevel4",
  "strengthBarSegment": "Form-module__FbQFba__strengthBarSegment",
  "strengthLabel": "Form-module__FbQFba__strengthLabel",
  "strengthLabel1": "Form-module__FbQFba__strengthLabel1",
  "strengthLabel2": "Form-module__FbQFba__strengthLabel2",
  "strengthLabel3": "Form-module__FbQFba__strengthLabel3",
  "strengthLabel4": "Form-module__FbQFba__strengthLabel4",
  "strengthRule": "Form-module__FbQFba__strengthRule",
  "strengthRuleIcon": "Form-module__FbQFba__strengthRuleIcon",
  "strengthRuleMet": "Form-module__FbQFba__strengthRuleMet",
  "strengthRuleUnmet": "Form-module__FbQFba__strengthRuleUnmet",
  "strengthRules": "Form-module__FbQFba__strengthRules",
  "success": "Form-module__FbQFba__success",
  "successText": "Form-module__FbQFba__successText",
  "textarea": "Form-module__FbQFba__textarea",
});
